import "flatpickr/dist/themes/material_blue.css";
import React, { useState, useEffect } from "react";
import { post, get } from "../../../helpers/api_helper";
import {
  GET_API_PARAMETER,
  SAVE_API_PARAMETER,
  DELETE_API_PARAMETER,
  SAVE_LIST_API_PARAMETER,
} from "../../../helpers/url_api_constant";

import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  Button,
  Form,
  FormGroup,
  Card,
  Col,
  CardBody,
  Container,
  Input,
  Label,
  Modal,
  Row,
  InputGroup,

} from "reactstrap";
import ConfirmDialog, {
  useConfirmDialog,
} from "../../../components/Custom/ConfirmDialog";
import MessageDialog, {
  useModalShowMessage,
} from "../../../components/Custom/MessageDialog";
import PropTypes from "prop-types";
import BootstrapTable from "react-bootstrap-table-next";
import { connect } from "react-redux";
//i18n
import { withTranslation } from "react-i18next";
import "../../../assets/scss/datatables.scss";
import paginationFactory from "react-bootstrap-table2-paginator";
import OverButton from "../../../components/Custom/Overbutton";
import Loading from "../../../components/Custom/Loading";
import { Link, useHistory } from "react-router-dom";
import moment from "moment";
import Flatpickr from "react-flatpickr"
import { getPermission } from "../../../helpers/auth_helper";

function APIParameter(props) {
  const searchObj = {};
  const createObj = { PID: "", ALIAS_NAME: "", SCHEDULE_DESC: "" };

  const permission = getPermission();
  // console.log(permission);

  const [readonly, setReadonly] = useState(false)
  const [pageAdd, setPageAdd] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modelDeviceList, setModelDeviceList] = useState([]);

  const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);

  const [userActionType, setUserActionType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const {
    showMessage,
    toggleModalMessage,
    bodyMessageModal,
    titleMessageModal,
  } = useModalShowMessage();
  const { showConfirm, toggleConfirm, messageConfirm } = useConfirmDialog();

  //ฝั่งซ้ายคือ ตัวแปล ฝั่งขวา คือ ฟังก์ชั่น Ex  modelDeviceList เป็น ตัวแปลที่ใช้ ส่วน  setModelDeviceListเป็น ฟังก์ชั่นที่ใช้ Set Value ให้ modelDeviceList

  const listData = [
    {
      PID: "1",
      SCHEDULE_NAME: "Alarm Report",
    },
    {
      PID: "2",
      SCHEDULE_NAME: "Flow Select Data Round 1",
    },
    {
      PID: "3",
      SCHEDULE_NAME: "Flow Select Data Round 2",
    },
    {
      PID: "4",
      SCHEDULE_NAME: "PIS User",
    },

  ];

  //sort Column//
  const defaultSorted = [
    {
      dataField: "PRIORITY_FLAG",
      order: "asc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "250",
        value: 250,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//

  // Action Button//
  const ManualDescription = (cellContent, row) => {
    return (
      // <AvForm className="needs-validation">
      <div>
        <Input
          type="textarea"
          // name="API_DESC"
          // errorMessage="Enter Description"
          className="form-control"
          disabled={permission.eAPP != true}
          onChange={e => {
            // console.log(e.target.value);
            setModelDeviceList(prevData => {
              return prevData.map(item => {
                // console.log(item);
                if (item.PID === row.PID) {
                  return { ...item, API_DESC: e.target.value };
                }
                return { ...item };
              });
            })
          }
          }
          value={row.API_DESC}
        />
      </div>
      // </AvForm>
    );
  };

  const InputUrl = (cellContent, row) => {
    return (
      // <AvForm className="needs-validation">
      <div>
        <Input
          type="text"
          // name="API_VALUE"
          // errorMessage="Enter Description"
          className="form-control"
          disabled={permission.eAPP != true}
          onChange={e => {
            // console.log(e.target.value);
            setModelDeviceList(prevData => {
              return prevData.map(item => {
                // console.log(item);
                if (item.PID === row.PID) {
                  return { ...item, API_VALUE: e.target.value };
                }
                return { ...item };
              });
            })
          }
          }
          value={row.API_VALUE}
        />
      </div>
      // </AvForm>
    );
  };


  const ButtonAction = (cellContent, row) => {
    return (
      <div>
        <OverButton
          onClick={() => {
            setReadonly(true);
            onEdit(row);
            setUserActionType("(View)");
          }}
          color="primary"
          icon="fas fa-eye"
          label="View"
        />
        <OverButton
          onClick={() => {
            setReadonly(false);
            onEdit(row);
            setUserActionType("(Edit)");
          }}
          color="info"
          icon="far fa-edit"
          label="Edit"
        />
        <OverButton
          onClick={() => {
            onDelete(row);
          }}
          color="danger"
          icon="fas fa-trash-alt"
          label="Delete"
        />
      </div>
    );
  };
  // Action Button//

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };

  //headerColumn
  const columns = [
    {
      dataField: "PRIORITY_FLAG",
      text: "No.",
      // formatter: CountIndexRow,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
    },
    {
      dataField: "ALIAS_NAME",
      text: "API Name",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "df2",
      text: "Value",
      isDummyField: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "50%",
        fontSize: "12px",
      },
      style: {
        width: "50%",
        fontSize: "12px",
      },
      sort: false,
      formatter: InputUrl,
    },
    {
      dataField: "df1",
      text: "Description",
      isDummyField: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "25%",
        fontSize: "12px",
      },
      style: {
        width: "25%",
        fontSize: "12px",
      },
      sort: false,
      formatter: ManualDescription,
    },
    
  ];
  //headerColumn

  //onInit//
  useEffect(function () {
    // console.log(modelDeviceList);
    resetSearch();
    resetModel();
    // setModelDeviceList(listData);
  }, []);
  //onInit//

  //Function CURL
  const resetSearch = () => {
    setSearchModel(searchObj);
    fetchData(searchObj);
  };

  const resetModel = () => {
    setCreateModel(createObj);
  };

  const onSearch = () => {
    fetchData(searchModel);
  };

  const onAdd = () => {
    setReadonly(false);
    resetModel();
    setPageAdd(true);
    setUserActionType("(Add Record)");
  };

  const onEdit = row => {
    setCreateModel(row);
    setPageAdd(true);
  };

  const onDelete = row => {
    setCreateModel(row);
    toggleConfirm("Do you want to delete ?");
  };

  const validateForm = () => {
    let bResult = true;
    if (createModel.ALIAS_NAME == "") {
      bResult = false;
    }

    if (createModel.UNITCODE == "") {
      bResult = false;
    }

    return bResult;
  };

  const fetchData = async (searchData) => {
    setIsLoading(true);
    try {
      let res = await post(GET_API_PARAMETER, searchData);
      // console.log(res);
      setModelDeviceList(res.data.apiParameterList);
      // setModelDeviceList(res.data.apiScheduleList.map(item => {
      //   return {
      //     ...item, SCHEDULE_TIME: moment(item.SCHEDULE_TIME).toDate(), SCHEDULE_TIME2: moment(item.SCHEDULE_TIME2).toDate(),
      //     SCHEDULE_TIME3: moment(item.SCHEDULE_TIME3).toDate()
      //   }
      // }));
    } catch (err) {
      toggleModalMessage(err.message);
    }
    setIsLoading(false);
  };


  const saveData = async () => {
    // console.log(modelDeviceList);
    setIsLoading(true);
    try {
      let res = await post(SAVE_LIST_API_PARAMETER, modelDeviceList);
      
      if (res.resultCode == 200) {
        res.isEditMode == 0 ? toggleModalMessage("Save success.") : toggleModalMessage("Update success.");
        setPageAdd(false);
        fetchData(searchModel);
      } else {
        toggleModalMessage(res.resultDescription);
      }
    } catch (err) {
      toggleModalMessage(err.message);
    }
    setIsLoading(false);

  };

  const deleteData = async () => {
    setIsLoading(true);
    try {
      let res = await post(DELETE_API_PARAMETER, createModel);
      toggleConfirm();
      if (res.resultCode == 200) {
        toggleModalMessage("Delete Success.");
        fetchData(searchModel);
      } else {
        toggleModalMessage(res.resultDescription);
      }
      setIsLoading(false);
    } catch (err) {
      toggleConfirm();
      toggleModalMessage(err.message);
      setIsLoading(false);
    }
  };
  //Function CURL

  function RenderList(prop) {
    // console.log(prop);
    return (
      <tr>
        <td className="text-center">{prop.indexlist}</td>
        <td className="text-center">{prop.data.Region}</td>
        <td className="text-center">
          <Button
            className="me-1 text-center"
            onClick={() => setPageAdd(true)}
            color="info"
          >
            <i className="far fa-edit"></i>
            &nbsp; Edit
          </Button>
          <Button
            onClick={() => setModalDelete(true)}
            // className="btn-rounded"
            color="danger"
          >
            <i className="fas fa-trash-alt"></i>
            &nbsp; Delete
          </Button>
        </td>
      </tr>
    );
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20">
                      {" "}
                      {props.t("API PMIS Parameter")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            System Config
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">API PMIS Parameter</li>
                      </ol>
                    </div>
                  </div>
                  <hr />
                  <Row className="mt-2">
                    <Col sm="12">
                      <div>
                        {/* แบบเดิมใน div ใช้ ClassName นี้ className="table-responsive" */}
                        <BootstrapTable
                          keyField="PID"
                          data={modelDeviceList}
                          columns={columns}
                          headerClasses="header-style"
                          rowStyle={rowStyleFontWhite}
                          defaultSorted={defaultSorted}
                        // pagination={paginationFactory(options)}
                        // hover
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col sm="3">
                      <span style={{ color: "#556ee6" }}>&nbsp; Update By :  {modelDeviceList.length > 0 ? modelDeviceList[0].UPDATE_USER : ''}</span>
                    </Col>
                    <Col
                      sm="9"
                      className="d-flex align-items-center justify-content-end">
                      <div className="d-grid gap-2 d-md-block">
                        {permission.eAPP && (
                          <Button
                            onClick={() => saveData()}
                            color="success"
                            className="btn w-md"
                          >
                            <i className="bx bx-save fa-lg"> </i> &nbsp; Save
                          </Button>
                        )}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/*start : ModalPageAdd */}
      <Modal size="lg" isOpen={pageAdd}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            Region {userActionType}
          </h5>
        </div>
        <div className="modal-body">
          <CardBody>
            <AvForm className="needs-validation">
              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center"
                  >
                    <span style={{ color: "#FF0E03" }}>* </span>
                    Region
                  </Label>
                  <Col sm={8}>
                    <AvField
                      // readOnly={readonly}
                      disabled={readonly}
                      name="ALIAS_NAME"
                      type="text"
                      errorMessage="Enter Region"
                      className="form-control basicborder"
                      // style={{ border: "solid 1px #FFFFFF" }}
                      validate={{ required: { value: true } }}
                      onChange={e =>
                        setCreateModel({
                          ...createModel,
                          ALIAS_NAME: e.target.value,
                        })
                      }
                      value={createModel.ALIAS_NAME}
                    />
                  </Col>
                </FormGroup>
              </Row>
              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center"
                  >
                    <span style={{ color: "#FF0E03" }}>* </span>
                    Unit Code
                  </Label>
                  <Col sm={8}>
                    <AvField
                      // readOnly={readonly}
                      disabled={readonly}
                      name="UNITCODE"
                      type="text"
                      errorMessage="Enter Unit Code"
                      className="form-control basicborder"
                      // style={{ border: "solid 1px #FFFFFF" }}
                      validate={{ required: { value: true } }}
                      onChange={e =>
                        setCreateModel({
                          ...createModel,
                          UNITCODE: e.target.value,
                        })
                      }
                      value={createModel.UNITCODE}
                    />
                  </Col>
                </FormGroup>
              </Row>

              <div className="text-center mt-2">
                {!readonly &&
                  <button
                    type="submit"
                    className="btn btn-success me-2"
                    onClick={() => saveData()}
                  >
                    <i className="far fa-save"></i> Save
                  </button>
                }
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setPageAdd(false)}
                >
                  <i className="fas fa-times"></i> Close
                </button>
              </div>

            </AvForm>
          </CardBody>
          {createModel.PID && (
            <Row className="mt-2">
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-start"
                  style={{ color: "#556ee6" }}
                >
                  Create By : {createModel.CREATE_USER} (  {moment(createModel.CREATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )
                </span>
              </Col>
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-end"
                  style={{ color: "#556ee6" }}
                >
                  Update By :  {createModel.UPDATE_USER} (  {moment(createModel.UPDATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )

                </span>
              </Col>
            </Row>
          )}
        </div>
        {/* -- Model Footer-- */}
        {/* <div className="modal-footer">
                <button type="button" className="btn btn-light" onClick={() =>
                  this.setState({ modal_backdrop: false })
                }>Close</button>
              </div> */}
        {/* -- Model Footer-- */}
      </Modal>
      {/*end : PageAdd */}

      {/*Loading */}
      <Loading show={isLoading} />
      {/*Loading */}

      {/* MessageDialog */}
      <MessageDialog
        isOpen={showMessage}
        hide={toggleModalMessage}
        title={titleMessageModal}
        message={bodyMessageModal}
      />

      {/* comfirmDialog */}
      <ConfirmDialog
        isOpen={showConfirm}
        hide={toggleConfirm}
        message={messageConfirm}
        onConfirm={deleteData}
      />
    </React.Fragment>
  );
}

APIParameter.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ APIParameter }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(APIParameter));

